export default function getResource(label, vars = []) {
    const resources = {
        bookAnAppointment: 'Book an Appointment',
        yourService: 'Your Service',
        free: 'FREE'
    };

    return resources[label];
}
